import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import useResizeObserver from '../../../hooks/useResizeObserver';
import Carousel from 'react-multi-carousel';
import ArrowsBtn from '../arrowsBtn/ArrowsBtn';
import classes from "./Carousel.module.css";
// import Tooltip from '../tooltip/Tooltip';
import 'react-multi-carousel/lib/styles.css';



const ButtonGroup = ({ next, previous, color, dropClassRightArrow, dropClassLeftArrow, show, showBtns, ...rest }) => {

    const { carouselState: { currentSlide, totalItems, slidesToShow }, } = rest;

    const { texts } = useSelector(state => state.translate);

    return (
        <> {show && <div>
            {currentSlide + slidesToShow < totalItems &&
                <div className={`${dropClassLeftArrow} ${classes.Arrow} `}>
                    {/* <Tooltip showTooltip={false} text={texts.next}> */}
                    <ArrowsBtn accessibilityDescription={texts.next} left onClick={() => next()} color={color} dropClass={`${dropClassLeftArrow}`} oneArrow={true} />
                    {/* </Tooltip> */}
                </div>}
            {showBtns && currentSlide % 1 === 0 && <div className={classes.BtnLeft} onClick={() => next()} />}
            {currentSlide !== 0 &&
                <div className={`${dropClassRightArrow} ${classes.Arrow} `}>
                    {/* <Tooltip showTooltip={false} text={texts.prev}> */}
                    <ArrowsBtn accessibilityDescription={texts.prev} right onClick={() => previous()} color={color} dropClass={`${dropClassRightArrow}`} oneArrow={true} />
                    {/* </Tooltip> */}
                </div>}
            {showBtns && currentSlide % 1 !== 0 && <div className={classes.BtnRight} onClick={() => previous()} />}
        </div>}</>
    );
};

const CarouselElem = ({ id, color, autoPlay, infinite, showDots, responsive, children, dropClassRightArrow, dropClassLeftArrow, dropClassDots, beforeChange, hover, showBtns, clientWidth, customItemWidth, customSpaceBetweenItems, fullItems }) => {

    const ref = useRef();
    const [slidesToSlide, setsSlidesToSlide] = useState();
    const [partialVisibilityGutter, setPartialVisibilityGutter] = useState(0);
    const [generateResponsive, setGenerateResponsive] = useState(responsive || null);
    const [showHiddenFirstItem, setShowHiddenFirstItem] = useState(0)
    const { width } = useResizeObserver(clientWidth);
    const itemWidth = customItemWidth ? customItemWidth : 185;
    const spaceBetweenItems = customSpaceBetweenItems ? customSpaceBetweenItems : 10;

    useEffect(() => {
        window.addEventListener('resize', calcSlidesToSlide);
        calcSlidesToSlide();

        return () => {
            window.removeEventListener('resize', calcSlidesToSlide);
        };
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        calcSlidesToSlide();
        // to do pnina
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generateResponsive]);

    useEffect(() => {
        if (width && !responsive) {
            let itemsPerPage = width / (itemWidth + spaceBetweenItems);
            if (fullItems) {
                itemsPerPage = Math.floor(itemsPerPage);
            }
            const remainingSpace = 1 - (itemsPerPage % 1);
            setGenerateResponsive({
                desktop: {
                    breakpoint: { max: 3000, min: 0 },
                    items: itemsPerPage,
                    partialVisibilityGutter: remainingSpace
                }
            })
            setPartialVisibilityGutter(itemsPerPage % 1);
        }
        // to do pnina
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [width]);

    useEffect(() => {
        setTabIndexForLiElements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref.current, children])

    const calcSlidesToSlide = () => {
        setsSlidesToSlide(checkCurrentResponsiveItems() || 1)
    }

    const setTabIndexForLiElements = () => {
        const carousel = document.querySelector('#' + id);
        if (!carousel) return;
        const liElements = carousel.querySelectorAll('li');
        if (!liElements) return;
        liElements.forEach(element => {
            const isHidden = element.ariaHidden === 'true';
            const clickAbles = element.querySelectorAll(`a, button, [tabindex="${isHidden ? 0 : -1}"]`)
            clickAbles.forEach(c => {
                c.setAttribute('tabIndex', isHidden ? -1 : 0);
            })
        });
    };

    const checkCurrentResponsiveItems = () => {
        const width = document.body.clientWidth;
        const currentWidthConfig = generateResponsive && Object.keys(generateResponsive)?.filter(key => width < generateResponsive?.[key].breakpoint.max && width >= generateResponsive?.[key].breakpoint.min);
        return Math.floor(generateResponsive?.[currentWidthConfig]?.items)
    }
    const handleSlideChange = (nextSlide) => {
        setShowHiddenFirstItem(nextSlide % 1 !== 0);
        beforeChange && beforeChange()
    };

    return <div id={id} className={classes.Carousel}>
        {generateResponsive && <Carousel
            key={id}
            ref={(el) => { ref.current = el; }}
            customButtonGroup={<ButtonGroup show={children.length > slidesToSlide} color={color} dropClassRightArrow={dropClassRightArrow} dropClassLeftArrow={dropClassLeftArrow} showBtns={showBtns} />}
            renderButtonGroupOutside={true}
            additionalTransfrom={0}
            arrows={false}
            afterChange={setTabIndexForLiElements}
            beforeChange={handleSlideChange}
            autoPlay={false}
            partialVisible={false}
            autoPlaySpeed={5000}
            centerMode={false}
            className={`${classes.CarouselWrap} ${hover && classes.CarouselWrapHover}`}
            containerClass={classes.CarouselContainer}
            dotListClass={`${classes.Dots} ${dropClassDots}  ${hover && classes.HoverOnItem}`}
            showDots={showDots && children.length > slidesToSlide}
            draggable
            focusOnSelect={false}
            rewind={true}
            infinite={infinite}
            keyBoardControl
            minimumTouchDrag={80}
            renderArrowsWhenDisabled={false}
            renderDotsOutside={true}
            responsive={generateResponsive}
            rewindWithAnimation={true}
            rtl={true}
            shouldResetAutoplay={true}
            sliderClass={classes.SliderClass}
            slidesToSlide={slidesToSlide}
            swipeable
            pauseOnHover={true}
        >
            {children}
        </Carousel>
        }
        {!showHiddenFirstItem ? <div className={classes.HiddenLastItem} style={{ width: (((itemWidth + spaceBetweenItems) * partialVisibilityGutter)) }} ></div> : ''}
        {showHiddenFirstItem ? <div className={classes.HiddenRightItem} style={{ width: (((itemWidth + spaceBetweenItems) * partialVisibilityGutter)) }} ></div> : ''}
    </div>
}

export default CarouselElem;